import ChevronLeftRoundedIcon from "@mui/icons-material/ChevronLeftRounded";
import ChevronRightRoundedIcon from "@mui/icons-material/ChevronRightRounded";
import { Box, IconButton, Slider, Stack } from "@mui/material";
import { useTheme } from '@mui/material/styles';

// key, anchor, open, setIsOpen are required
export default function ManagedSlider(props) {
    const { max, value, onChange } = props;
    
    const theme = useTheme();

    const handleChange = (value) => {
        onChange(value);
    };

    return (
        <Stack
            direction="row"
            gap={0}
            alignItems="center"
        >
            <IconButton
                color="primary"
                sx={{ width: "32px", height: "32px", padding: "2px" }}
                disabled={value === 0}
                onClick={() => {
                    handleChange(value > 0 ? value - 1 : 0);
                }}
            >
                <ChevronLeftRoundedIcon sx={{ fontSize: "28px" }} />
            </IconButton>
            <Stack sx={{ position: "relative" }}>
                <Box
                    sx={{
                        position: "absolute",
                        top: 0,
                        left: 0,
                        transform: "translateY(-6px)",
                        fontSize: "12px",
                        width: "100%",
                        textAlign: "center",
                    }}
                >
                    {value}/{max}
                </Box>
                <Slider
                    min={0}
                    max={max}
                    value={value}
                    sx={{
                        height: "2px",
                        ".MuiSlider-mark": {
                            backgroundColor: theme?.custom?.mainButtonHighlight,
                        },
                        ".MuiSlider-thumb": {
                            height: "12px",
                            width: "12px",
                        },
                        ...props.sx,
                    }}
                    marks
                    onChange={(e) => {
                        //@ts-ignore
                        handleChange(e.target.value);
                    }}
                />
            </Stack>
            <IconButton
                color="primary"
                sx={{ width: "32px", height: "32px", padding: "2px" }}
                disabled={value === max}
                onClick={() => {
                    handleChange(value < max ? value + 1 : max);
                }}
            >
                <ChevronRightRoundedIcon sx={{ fontSize: "28px" }} />
            </IconButton>
        </Stack>
    );
}
